import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalCompanyCreateProps {}

const ModalCompanyCreate = ({}: ModalCompanyCreateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createCompany');
  const onClose = () => {
    closeSingleModal('createCompany');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Nova companhia"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Company.Create />
    </Modal>
  );
};

export default ModalCompanyCreate;
